import { gql } from '@apollo/client';

export const getSoAdditional = gql`
query GetSo($id: String!) {
  getSo(id: $id) {
    _id
    soNumber
    status
    source
    email
    phoneNumber
    fullName
    firstName
    lastName
    productTypeId {
      _id
      code
      name
    }
    funnel {
      latestStep
      steps {
        code
        openedAt
      }
    }
    productTypeSpecific {
      additionalInsuranceInfo {
        physicalExamination
        specialistExaminations
        diagnostic
        laboratoryExaminations
        mrCt
        physicalTherapy
        smallOperatingCycles
        reasonOfPurchase
        perMonthPayment
      }
      insuredPerson {
        firstName
        lastName
        birthDate
        city
        cityKompareId
        zipCode
        oib
        street
        streetKompareId
        streetAndHouseNumber
        houseNumber
        gender
        personType
        partnerContactEmail
        oldPolicyNumber
        newPolicyStartDate
      }
      renewalOf {
        productTypeCode
        productCode
        newPolicyStartDate
        oldPolicy {
          brandCode
          brandName
          endDate
        }
      }
    }
    admin {
      name
      email
      avatar
    }
  }
}`
